module.exports = __webpack_public_path__ + "img/clock-warning.d36f468c.svg";